/**
 * Hebrew Search Normalizer
 * Automatically converts between geresh (׳ U+05F3) and gershayim (״ U+05F4) to apostrophe (')
 */

(function() {
  // Normalize Hebrew punctuation characters
  function normalizeHebrewSearch(searchTerm) {
    if (!searchTerm) return searchTerm;
    
    // Replace Hebrew geresh (׳ U+05F3) and gershayim (״ U+05F4) with apostrophe (')
    // Also handle the combining geresh (׳) if it appears
    const normalized = searchTerm
      .replace(/[\u05F3\u05F4]/g, "'")  // Hebrew geresh and gershayim
      .replace(/׳/g, "'");               // Alternative geresh representation
    
    return normalized;
  }

  // Wait for DOM to be ready
  function init() {
    // Intercept all search form submissions
    document.addEventListener('submit', function(e) {
      if (e.target.matches('form[action*="/search"]')) {
        const input = e.target.querySelector('input[name="q"]');
        if (input && input.value) {
          const original = input.value;
          input.value = normalizeHebrewSearch(input.value);
          if (original !== input.value) {
            console.log('Search normalized:', original, '→', input.value);
          }
        }
      }
    });

    // Intercept input events for predictive search
    document.addEventListener('input', function(e) {
      if (e.target.matches('input[name="q"], input[type="search"]')) {
        const original = e.target.value;
        const normalized = normalizeHebrewSearch(original);
        if (original !== normalized) {
          e.target.value = normalized;
          // Trigger input event to update predictive search
          e.target.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
